import { render, staticRenderFns } from "./PdfEditor.vue?vue&type=template&id=48d359c8&"
import script from "./PdfEditor.vue?vue&type=script&lang=js&"
export * from "./PdfEditor.vue?vue&type=script&lang=js&"
import style0 from "./PdfEditor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PdfEditor.vue?vue&type=style&index=1&lang=scss&"
import style2 from "../../assets/tailwind.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports